<template>
    <vs-prompt
        title="Edit Story"
        accept-text="Save"
        button-cancel="border"
        @accept="submitStory"
        @close="init"
        :is-valid="validateForm"
        :active.sync="activePrompt"
    >
        <EditForm
            v-if="activePrompt"
            :activePrompt="activePrompt"
            :story="storyLocal"
            @accept="submitStory"
            @update="updateLocalStory"
            @close="activePrompt = false"

        />
    </vs-prompt>
</template>
<script>
import EditForm from './EditForm'
import trackAnalytics from '@/helpers/trackAnalytics'

export default {
  components: {
    EditForm,
  },
  props: {
    displayPrompt: {
      type: Boolean,
      required: true
    },
    storyId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      storyLocal: { tag: { value: 'note' }}
    }
  },
  computed: {
    activePrompt: {
      get () {
        return this.displayPrompt
      },
      set (value) {
        this.$emit('hideDisplayPrompt', value)
      }
    },
    validateForm () {
      return !this.errors.any() && this.storyLocal.title
    }
  },
  watch: {
    // TODO: refactor -> move validateForm() -> into EditForm component
    'storyLocal.title': {
      handler (title) {
        if (title === '') {
          this.storyLocal.title = null
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.storyLocal = Object.assign({}, this.$store.getters.getStory(this.storyId))
    },
    submitStory () {
      console.log('SUBMITT')
      this.$store.dispatch('UPDATE_STORY', this.storyLocal)
      trackAnalytics(this, 'app_action', 'update_story', null, this.$store.getters.daysFromRegistration)
    },
    updateLocalStory (story) {
      this.storyLocal = story
    },
  }
}
</script>
